import React, { useContext, useState } from 'react';
import axios from "axios";
import maincss from './MainCSS.module.css';
import Header from './Header';
import { urlContext } from './UrlContext';

const AddClient = () => {

    const { baseurl } = useContext(urlContext);

    const url = baseurl + "/addClient.php";
    const url2 = baseurl + "/updateNewClients.php";

    const submitForm = (event) => {
        event.preventDefault();
        
        axios
            .post(url, formData)
            .then((response) => {
                console.log(response.data);
                if (response.data === "posted") {
                    alert("Client Added");
                } else {
                    alert("Unsuccessfull");
                }
            }).catch((error) => {
                console.log(error);
            });

        
        axios
            .post(url2, formData)
            .then((response) => {
                console.log(response.data);
            }).catch((err) => {
                console.log(err);
            })

    };

    const [formData, setFormData] = useState({
        clientname: "",
        accountno: "",
        phoneno: "",
        amount: "",
        router: "",
        ip: "",
        clientstatus: "INACTIVE",
        dateadded: "",
    });

    const handleFormChange = (event) => {
        const {name, value} = event.target;
        setFormData({...formData, [name]: value})
        console.log(formData);
    }

    return (
        <div>
            <Header />
            <form onSubmit={submitForm} className={maincss.addClientForm}>
                <h1>Add Client</h1>
                    <fieldset>
                        <legend>Client Information</legend>
                        <label htmlFor="clientname">Client Name</label>
                        <input type="text" name="clientname" required onChange={handleFormChange} />
                        <label htmlFor="accountno">Account No</label>
                        <input type="text" name="accountno" required onChange={handleFormChange} />
                        <label htmlFor="phoneno">Phone No</label>
                        <input type="text" name="phoneno" required onChange={handleFormChange} />
                        <label htmlFor="amount">Amount</label>
                        <input type="text" name="amount" required onChange={handleFormChange} />
                        <label htmlFor="router">Router</label>
                        <select name='router' required onChange={handleFormChange}>
                            <option value="" disabled selected>Select router</option>
                            <option value="MIKROTIK 71">MIKROTIK 71</option>
                            <option value="FIBERLINK">FIBERLINK</option>
                        </select>
                        <label htmlFor="ip">Ip</label>
                        <input type="text" name="ip" required onChange={handleFormChange} />
                        <label htmlFor='dateadded'>Date Added</label>
                        <input type='date' name='dateadded' onChange={handleFormChange} />
                    </fieldset>
                <button>Submit</button>
            </form>
        </div>
    )
}

export default AddClient;